export const SOURCES = {
  foedevarestyrelsenOptoening: {
    title: "Optøning af mad - Fødevarestyrelsen",
    url: "https://foedevarestyrelsen.dk/kost-og-foedevarer/alt-om-mad/god-koekkenhygiejne/saadan-goer-du/optoening"
  },
  foedevarestyrelsenOpbevaring: {
    title: "Opbevar mad korrekt: Sådan holder dine fødevarer sig friske - Fødevarestyrelsen",
    url: "https://foedevarestyrelsen.dk/kost-og-foedevarer/alt-om-mad/madspild-i-hjemmet/opbevar-maden-korrekt"
  },
  foedevarestyrelsenHoldbarhed: {
    title: "Sådan vurderer du madens holdbarhed - og undgår madspild - Fødevarestyrelsen",
    url: "https://foedevarestyrelsen.dk/kost-og-foedevarer/alt-om-mad/madspild-i-hjemmet/vurder-madens-holdbarhed"
  },
  foedevarestyrelsenHygiejne: {
    title: "Sådan får du styr på hygiejnen ved madlavning - i private hjem - Fødevarestyrelsen",
    url: "https://foedevarestyrelsen.dk/kost-og-foedevarer/alt-om-mad/god-koekkenhygiejne/saadan-goer-du"
  },
  foedevarestyrelsenBakterier: {
    title: "Sådan undgår du at blive syg af campylobacter eller salmonella i mad - Fødevarestyrelsen",
    url: "https://foedevarestyrelsen.dk/kost-og-foedevarer/alt-om-mad/god-koekkenhygiejne/undgaa-bakterier-og-virus/salmonella-og-campylobacter"
  },
  taenkNedfrysning: {
    title: "Sådan fryser du bedst din mad ned | Forbrugerrådet Tænk",
    url: "https://taenk.dk/forbrugerliv/mad-og-indkoeb/saadan-nedfryser-du-din-mad-bedst"
  },
  taenkOptoening: {
    title: "Optøning: Sådan tør du bedst mad op | Forbrugerrådet Tænk",
    url: "https://taenk.dk/forbrugerliv/mad-og-indkoeb/optoening-saadan-toer-du-bedst-mad-op"
  },
  taenkHoldbarhed: {
    title: "Stop madspild: Få styr på holdbarhed og opbevaring af mad | Forbrugerrådet Tænk",
    url: "https://taenk.dk/forbrugerliv/mad-og-indkoeb/holdbarhed-opbevar-din-mad-saa-den-holder-laengere"
  },
  arlaOst: {
    title: "Kan man fryse ost og hvad skal man vide | Arla",
    url: "https://www.arla.dk/opskrifter/leksikon/viden/kan-man-fryse-ost/"
  },
  arlaFloede: {
    title: "Kan man fryse fløde og hvad skal man vide | Arla",
    url: "https://www.arla.dk/opskrifter/leksikon/viden/kan-man-fryse-flode/"
  },
  arlaMaelk: {
    title: "Hvordan holder mælk sig bedst? | Arla",
    url: "https://www.arla.dk/produkter/malk/artikler/hvordan-holder-maelk-sig-bedst/"
  },
  arlaSmoer: {
    title: "Smør og anvendelse i madlavning | Arla",
    url: "https://www.arla.dk/opskrifter/leksikon/ravarer/smor/"
  },
  arlaYoghurt: {
    title: "Yoghurt - oprindelse og anvendelse | Arla",
    url: "https://www.arla.dk/opskrifter/leksikon/ravarer/yoghurt/"
  },
  arlaCremeFraiche: {
    title: "Creme fraiche – Anvendelse i det søde og salte køkken | Arla",
    url: "https://www.arla.dk/opskrifter/leksikon/ravarer/creme-fraiche/"
  },
  arlaKylling: {
    title: "Kylling guide med udskæringer og anvendelse | Arla",
    url: "https://www.arla.dk/opskrifter/leksikon/guider/kyllingguide/"
  },
  arlaKartofler: {
    title: "Kartofler guide med sorter og anvendelse | Arla",
    url: "https://www.arla.dk/opskrifter/leksikon/guider/kartoffelguide/"
  },
  arlaBaer: {
    title: "Danske sommerbær | Arla",
    url: "https://www.arla.dk/opskrifter/leksikon/guider/baerguide/"
  },
  arlaGaer: {
    title: "Gær og anvendelse i bagning | Arla",
    url: "https://www.arla.dk/opskrifter/leksikon/ravarer/gar/"
  },
  samvirkeRester: {
    title: "10 rester, du kan fryse til senere brug for at minimere madspild | Samvirke",
    url: "https://samvirke.dk/artikler/10-rester-du-kan-fryse-til-senere-brug-for-at-minimere-madspild"
  },
  samvirkeKaffe: {
    title: "Kan jeg fryse kaffe og forlænge holdbarheden? | Samvirke",
    url: "https://samvirke.dk/artikler/kan-jeg-fryse-kaffe-og-forlaenge-holdbarheden"
  },
  samvirkeBaer: {
    title: "Hvorfor skal frosne bær koges, når friske bær ikke skal? | Samvirke",
    url: "https://samvirke.dk/artikler/hvorfor-skal-frosne-baer-koges-naar-friske-baer-ikke-skal"
  }
};
